import { QUADRUPLE } from "../../../constants/numbers.consts.js";
export default {
    styleOverrides: {
        paper: ({ theme }) => ({
            borderRadius: theme.spacing(QUADRUPLE),
        }),
    },
};
